import { useEffect, useState } from "react";

export default function Preloader() {
  const [count, setCount] = useState(0);
  const [exiting, setExiting] = useState(false);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    let n = 0;
    let exitTimer;
    let hideTimer;
    const id = setInterval(() => {
      n += Math.floor(Math.random() * 9) + 5;
      if (n >= 100) {
        n = 100;
        clearInterval(id);
        exitTimer = setTimeout(() => setExiting(true), 350);
        hideTimer = setTimeout(() => setHidden(true), 350 + 1100);
      }
      setCount(n);
    }, 70);
    return () => {
      clearInterval(id);
      clearTimeout(exitTimer);
      clearTimeout(hideTimer);
    };
  }, []);

  if (hidden) return null;

  return (
    <div
      className="fixed inset-0 z-[100] bg-[#030303] flex items-end pointer-events-none"
      style={{
        transform: exiting ? "translateY(-100%)" : "translateY(0)",
        transition: "transform 1.1s cubic-bezier(0.76, 0, 0.24, 1)",
      }}
      data-testid="preloader"
    >
      <div className="w-full max-w-screen-2xl mx-auto px-6 md:px-12 xl:px-24 pb-10 md:pb-14 flex items-end justify-between">
        <span className="font-mono text-xs md:text-sm uppercase tracking-[0.3em] text-[#8a8a8a]">
          Initialising / Ziraminds AI
        </span>
        <span
          className="font-display text-[#fafafa]"
          style={{ fontSize: "clamp(3rem, 10vw, 9rem)", lineHeight: 0.9 }}
        >
          {String(count).padStart(3, "0")}
          <span className="text-[#d4ff00]">.</span>
        </span>
      </div>
    </div>
  );
}
